export default __webpack_public_path__ + "static/media/cleanproCuciEn.3a5b5c5c.jpg";